import { render, staticRenderFns } from "./removeWarehouseForm.vue?vue&type=template&id=5d73a11a&scoped=true&"
import script from "./removeWarehouseForm.vue?vue&type=script&lang=js&"
export * from "./removeWarehouseForm.vue?vue&type=script&lang=js&"
import style0 from "./removeWarehouseForm.vue?vue&type=style&index=0&id=5d73a11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73a11a",
  null
  
)

export default component.exports